import { useEffect, useState } from 'react'
import { Stack, TableContainer, Table, Thead, Tr, Th, Tbody, Td, IconButton, Select, Text, Spinner, useToast } from '@chakra-ui/react'
import { BiDownload } from 'react-icons/bi'
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import { GET } from '../../../utils/ApiRequestProvider'

export default function History() {
    const toast = useToast();
    const business = useSelector((state: any) => state.selections.value?.business);
    const [details, setDetails] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(false);

    const convertDate = (date: string | null) => (date ? new Date(date).toLocaleString() : '');

    async function FetchList() {
        if (!business?.id) return;
        setLoading(true);
        try {
            const res = await GET(`/api/billing/${business.id}/history`);
            const rows = (res.data ?? []).map((r: any) => ({
                invoiceNumber: r.invoice_number ?? r.invoiceNumber,
                invoiceStatus: r.status,
                invoiceDate: convertDate(r.billing_date ?? r.billingDate),
                plan: r.description ?? r.plan ?? '',
                billedAmount: r.amount,
                currency: r.currency,
                creditsPurchased: r.credits_purchased ?? 0,
                creditsAdjustment: r.credits_adjustment ?? 0,
                creditsBroughtForward: r.credits_brought_forward ?? 0,
                invoices: r.invoices ?? 0,
                invoiceCredits: r.invoice_credits ?? 0,
                bankStatementsProcessed: r.bank_statements_processed ?? 0,
                bankStatementsCredits: r.bank_statements_credits ?? 0,
                otherDocumentProcessed: r.other_document_processed ?? 0,
                otherDocumentCredits: r.other_document_credits ?? 0,
                totalCreditsUsed: r.total_credits_used ?? 0,
            }));
            setDetails(rows);
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error',
                isClosable: false,
                duration: 1000,
                position: 'top-right'
            });
        }
        setLoading(false);
    }

    useEffect(() => {
        FetchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [business]);

    return (
        <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
            <TableContainer h={'sm'} overflowY={'scroll'}>
                <Table size='sm'>
                    <Thead position={'sticky'} top={'0%'} zIndex={1} h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                        <Tr>
                            <Th
                                color={'white'}
                                isNumeric
                            >
                                Invoice Number
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Download
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Invoice Status
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Invoice Date
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Plan
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Billed Amount
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Currency
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Credits Purchased
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Credits Adjustment
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Credits Brought Forward
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Invoices
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Invoice Credits
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Bank Statements Processed
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Bank Statements Credits
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Other Document Processed
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Other Document Credits
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Total Credits Used
                            </Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            details.length === 0 ? (
                                <Tr>
                                    <Td colSpan={17} textAlign={'center'}>
                                        {loading ? <Spinner size={'sm'} color={'primary.400'} /> : 'No Data Available'}
                                    </Td>
                                </Tr>
                            ) :
                            details.map((row, i) => (
                                <Tr key={i}>
                                    <Td textAlign={'center'}>{row.invoiceNumber}</Td>
                                    <Td textAlign={'center'}>
                                    {/* {row.download} */}
                                        <IconButton
                                        aria-label="Download"
                                        icon={<BiDownload />}
                                        color={'green.400'}
                                        bg={'transparent'}
                                        fontSize={'xl'}
                                        rounded={'full'}
                                    /></Td>
                                    <Td>{row.invoiceStatus}</Td>
                                    <Td>{row.invoiceDate}</Td>
                                    <Td>{row.plan}</Td>
                                    <Td isNumeric>{row.billedAmount}</Td>
                                    <Td>{row.currency}</Td>
                                    <Td isNumeric>{row.creditsPurchased}</Td>
                                    <Td isNumeric>{row.creditsAdjustment}</Td>
                                    <Td isNumeric>{row.creditsBroughtForward}</Td>
                                    <Td isNumeric>{row.invoices}</Td>
                                    <Td isNumeric>{row.invoiceCredits}</Td>
                                    <Td isNumeric>{row.bankStatementsProcessed}</Td>
                                    <Td isNumeric>{row.bankStatementsCredits}</Td>
                                    <Td isNumeric>{row.otherDocumentProcessed}</Td>
                                    <Td isNumeric>{row.otherDocumentCredits}</Td>
                                    <Td isNumeric>{row.totalCreditsUsed}</Td>
                                </Tr>
                            ))
                        }
                    </Tbody>
                </Table>
            </TableContainer>
            <Stack
                direction={'row'}
                justify={"space-between"}
                align={'center'}
            >
                <Text>Showing {details.length} of {details.length} results</Text>
                <Stack direction={'row'} spacing={4}>
                    <Select defaultValue={10}>
                        <option value={5}>5 Per Page</option>
                        <option value={10}>10 Per Page</option>
                        <option value={25}>25 Per Page</option>
                        <option value={50}>50 Per Page</option>
                    </Select>
                    <Stack direction={'row'}>
                        <IconButton
                            aria-label="Previous"
                            icon={<FaArrowLeft />}
                            rounded={'full'}
                        />
                        <IconButton
                            aria-label="Previous"
                            icon={<FaArrowRight />}
                            rounded={'full'}
                        />
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}